/**
 * ZR Aktions-Popup — oeffnet verzoegert, merkt sich das Wegklicken und laesst
 * sich ueber einen seitlichen Reiter wieder holen.
 *
 * Ersetzt das EcomSend-App-Popup. Bewusst ohne Abhaengigkeit zu
 * zr-fit-modal.js: Das Fitment-Modal existiert genau einmal und wird von
 * Buttons geoeffnet, dieses hier oeffnet sich selbst und braucht eine
 * Wiedervorlage-Logik.
 *
 * Die Wiedervorlage liegt in localStorage. Faellt der Zugriff aus (privater
 * Modus, blockierte Site-Daten), zeigen wir das Popup lieber einmal zu viel
 * als gar nicht — deshalb sind beide Zugriffe in try/catch und der Fehlerfall
 * bedeutet "noch nicht gesehen".
 */
(function () {
  var wurzel = document.querySelector("[data-zr-aktion]");
  if (!wurzel) return;

  var dialog = wurzel.querySelector("[data-zr-akt-dialog]");
  var schliessen = wurzel.querySelectorAll("[data-zr-akt-close]");
  var reiter = document.querySelector("[data-zr-akt-tab]");

  var SCHLUESSEL = "zrAktionPopup:" + (wurzel.dataset.version || "1");
  var tage = parseInt(wurzel.dataset.dismissDays, 10);
  if (isNaN(tage)) tage = 7;
  var verzoegerung = parseInt(wurzel.dataset.delay, 10);
  if (isNaN(verzoegerung)) verzoegerung = 4;

  var vorherFokussiert = null;

  function gesehen() {
    try {
      var roh = window.localStorage.getItem(SCHLUESSEL);
      if (!roh) return false;
      return Date.now() < parseInt(roh, 10);
    } catch (e) {
      return false;
    }
  }

  function merken() {
    try {
      window.localStorage.setItem(
        SCHLUESSEL,
        String(Date.now() + tage * 24 * 60 * 60 * 1000)
      );
    } catch (e) {
      /* Kein Speicher verfuegbar — dann eben nur fuer diese Seitenansicht. */
    }
  }

  /* Fokus im Dialog halten, solange er offen ist. */
  function fokusFalle(e) {
    if (e.key !== "Tab") return;
    var ziele = dialog.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!ziele.length) return;
    var erstes = ziele[0];
    var letztes = ziele[ziele.length - 1];
    if (e.shiftKey && document.activeElement === erstes) {
      e.preventDefault();
      letztes.focus();
    } else if (!e.shiftKey && document.activeElement === letztes) {
      e.preventDefault();
      erstes.focus();
    }
  }

  function beiTaste(e) {
    if (e.key === "Escape") zu();
    else fokusFalle(e);
  }

  function auf() {
    vorherFokussiert = document.activeElement;
    wurzel.classList.add("is-open");
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", beiTaste);
    var ersterKnopf = dialog.querySelector("[data-zr-akt-close]");
    if (ersterKnopf) ersterKnopf.focus();
    if (reiter) reiter.classList.remove("is-visible");
  }

  function zu() {
    wurzel.classList.remove("is-open");
    document.body.style.overflow = "";
    document.removeEventListener("keydown", beiTaste);
    merken();
    if (reiter) reiter.classList.add("is-visible");
    if (vorherFokussiert && vorherFokussiert.focus) vorherFokussiert.focus();
  }

  schliessen.forEach(function (el) {
    el.addEventListener("click", zu);
  });

  if (reiter) {
    reiter.addEventListener("click", function () {
      auf();
    });
  }

  if (gesehen()) {
    if (reiter) reiter.classList.add("is-visible");
  } else {
    window.setTimeout(auf, verzoegerung * 1000);
  }
})();
